import { render } from "./Product.vue?vue&type=template&id=169aeeba"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=169aeeba&lang=postcss"
script.render = render

export default script